/* tslint:disable */
import * as Icons from './IconNames';
import IconContents from './IconContents';
export { Icons, IconContents };
